import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './Overview.css'
import { Bar } from 'react-chartjs-2'
import firebase from '../../utils/firebase';

const TIMES = [
    "12:00am",
    "1:00am",
    "2:00am",
    "3:00am",
    "4:00am",
    "5:00am",
    "6:00am",
    "7:00am",
    "8:00am",
    "9:00am",
    "10:00am",
    "11:00am",
    "12:00pm",
    "1:00pm",
    "2:00pm",
    "3:00pm",
    "4:00pm",
    "5:00pm",
    "6:00pm",
    "7:00pm",
    "8:00pm",
    "9:00pm",
    "10:00pm",
    "11:00pm",
  
]

export default () => {
    const { id } = useParams();
    const [poll, setPoll] = useState({})
    const [chartData, setChartData] = useState({});
    const [answerLink, setAnswerLink] = useState("");

    useEffect(() => {
        
        firebase.getPollById(id)
            .then((res) => {
                setPoll(res.val());

                
            })
    }, [])

    useEffect(() => {
        setupChart();
        setAnswerLink('Share this link: http://localhost:3000/overview/' + poll.answerForm)
    }, [poll])

    const setupChart =  () => {
        if (poll.isAllDay) {
            setChartData({
                labels: TIMES,
                datasets: [{ 
                    label: 'Number of people available',
                    barPercentage: 0.5,
                    barThickness: 25,
                    maxBarThickness: 60,
                    minBarLength: 2,
                    data: [],
                    backgroundColor: 'rgba(82, 34, 208, 0.6)'
                }],
            })
        } else {
            let start = TIMES.findIndex((x) => x === poll.startTime);
            let end = TIMES.findIndex((x) => x === poll.endTime);
           
            console.log('Start', start);
            let times = TIMES.slice(start, end);
            console.log('Times: ', times)
            setChartData({
                labels: times,
                datasets: [{ 
                    label: 'Number of people available',
                    barPercentage: 0.5,
                    barThickness: 25,
                    maxBarThickness: 60,
                    minBarLength: 2,
                    data: [],
                    backgroundColor: 'rgba(82, 34, 208, 0.6)'
                }],
            })
        }
    }
    return (
        <div className="Overview">
            <main className="container">
                <h1 className="page-heading">Overview</h1>
                <p className="event-title">{poll.title}</p>
                <p className="event-date">{poll.date}</p>
                <p className="answer-link">
                    {answerLink}
                </p>
                <div>
                    <Bar data={chartData}/>
                </div>
            </main>
        </div>
    );
}